import axios from 'axios';

import { getRestApiUrl } from '../../Utils/urls';

export const createPaymentAccount = async (
  userEmail: string,
): Promise<{ stripeConnectedAccountId: string } | void> => {
  const url = `${getRestApiUrl()}/create-customer-account`;

  try {
    const response = await axios.post(url, { emailAddress: userEmail });

    if (response.status === 200) {
      return response.data;
    } else {
      console.error('Error creating payment account:', response.status, response.statusText);
      throw new Error('Error creating payment account');
    }
  } catch (error) {
    console.error('Error creating payment account:', error);
  }
};

export const getPaymentLink = async (userEmail: string): Promise<{ url: string } | void> => {
  const url = `${getRestApiUrl()}/payment-login-link`;

  try {
    const response = await axios.post(url, { emailAddress: userEmail });

    if (response.status === 200) {
      return response.data;
    } else {
      console.error('Error getting login link:', response.status, response.statusText);
      throw new Error('Error getting login link');
    }
  } catch (error) {
    console.error('Error getting login link:', error);
  }
};

export const getOnboardingLink = async (
  stripeConnectedAccountId: string,
): Promise<{ url: string } | void> => {
  const url = `${getRestApiUrl()}/create-account-link`;

  try {
    const response = await axios.post(url, { account: stripeConnectedAccountId });

    if (response.status === 200) {
      return response.data;
    } else {
      console.error('Error getting onboarding link:', response.status, response.statusText);
      throw new Error('Error getting onboarding link');
    }
  } catch (error) {
    console.error('Error getting onboarding link:', error);
  }
};
